export default (): string | null => {
  return sessionStorage.getItem("@Enterprise:id");
};
